<script setup>
import { useAppStore } from '../store/app';
import Loader from './Loader.vue';
import { format } from 'date-fns';
import { ref } from 'vue';
const store = useAppStore();

const headers = [
  {
    title: 'Date',
    key: 'transactionDate',
  },
  {
    title: 'Amount',
    key: 'amount',
  },
  {
    title: 'Status',
    key: 'status',
  },
  {
    title: 'Payment Type',
    key: 'type',
  },
  {
    title: 'Transaction Number',
    key: 'transactionNumber',
  },
  {
    title: 'Description',
    key: 'transactionError',
  },
];

const statusColorMap = ref({
  Successful: 'success',
  Failed: 'red',
});
</script>
<template>
  <v-card>
    <Loader></Loader>
    <v-data-table
      :headers="headers"
      :items="store.customerTransactionsHistory"
      :loading="store.appLoading"
      class="elevation-1">
      <template v-slot:[`item.amount`]="{ item }">
        $ {{ (parseFloat(item.amount) / 100).toFixed(2) }}
      </template>
      <template v-slot:[`item.transactionDate`]="{ item }">
        {{ format(new Date(item.transactionDate), 'dd/MM/yyyy') }}
      </template>
      <template v-slot:[`item.transactionError`]="{ item }">
        {{ item.transactionError || 'N/A' }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip density="compact" :color="statusColorMap[`${item?.status}`] || 'grey'">
          {{ item?.status }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>
